import _regeneratorRuntime from "/home/runner/work/online-shopper-web/online-shopper-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/runner/work/online-shopper-web/online-shopper-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { getOrCreateId } from './domains/id';
import { ingestTradeIn, egressLastTradeIn } from './domains/trade-in';
/**
 * Looks for a Consumer UUID in storage and creates one if it does not exist
 */

export function getId() {
  return getOrCreateId();
}
/**
 * Ingests a trade in and persists it to local storage for future retrieval.
 * Validates the data against the `TradeIn` schema, will throw an error if
 * the data provided is invalid or if it is unable to save.
 */

export function emitTradeIn(data) {
  return ingestTradeIn(data);
}
/**
 * Retrieves the last Trade In from localStorage.
 * Will return an empty object if no Trade In was found.
 */

export function fetchLastTradeIn() {
  return egressLastTradeIn();
}
/**
 * Removes the last Trade In from localStorage.
 */

export function discardTradeIn() {
  return _discardTradeIn.apply(this, arguments);
}

function _discardTradeIn() {
  _discardTradeIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            ingestTradeIn({});

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _discardTradeIn.apply(this, arguments);
}